// extracted by mini-css-extract-plugin
export default {"wrapper":"backToBottomButton_wrapper__4+X4W","icon":"backToBottomButton_icon__QK8CS","fadebottom":"backToBottomButton_fadebottom__nii75"};